const INVALID_PROFILES_KEY = 'invalid-profiles';

export const getInvalidProfileIds = (): string[] => {
  try {
    const stored = localStorage.getItem(INVALID_PROFILES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Failed to read invalid profiles from localStorage:', error);
    return [];
  }
};

export const isProfileInvalid = (profileId: string): boolean => {
  const invalidIds = getInvalidProfileIds();
  return invalidIds.includes(profileId);
};

export const markProfileAsInvalid = (profileId: string): void => {
  try {
    const invalidIds = getInvalidProfileIds();
    if (!invalidIds.includes(profileId)) {
      invalidIds.push(profileId);
      localStorage.setItem(INVALID_PROFILES_KEY, JSON.stringify(invalidIds));
    }
  } catch (error) {
    console.error('Failed to mark profile as invalid:', error);
  }
};

export const clearInvalidProfile = (profileId: string): void => {
  try {
    const invalidIds = getInvalidProfileIds();
    const filtered = invalidIds.filter((id) => id !== profileId);
    localStorage.setItem(INVALID_PROFILES_KEY, JSON.stringify(filtered));
  } catch (error) {
    console.error('Failed to clear invalid profile:', error);
  }
};
